import {registerGraphNodeIn} from "@cm/graph-v3"

export const registerMaterialGraphNode = registerGraphNodeIn("material")
